import { Fallback } from '@amagimedia/commons/src/components/Fallback';
import { FC, lazy, Suspense } from 'react';
import { LoadExternalServices } from './LoadExternalServices';

const STVContentPartnerAppLazy = lazy(
  () => import('@amagimedia/stv-content-partner'),
);

export const STVContentPartnerApp: FC = () => {
  return (
    <>
      <LoadExternalServices />
      <Suspense fallback={<Fallback />}>
        <STVContentPartnerAppLazy />
      </Suspense>
    </>
  );
};
